import { render } from "./ViewAskResetPassword.vue?vue&type=template&id=938d0ab4&ts=true"
import script from "./ViewAskResetPassword.vue?vue&type=script&lang=ts"
export * from "./ViewAskResetPassword.vue?vue&type=script&lang=ts"

import "./ViewAskResetPassword.vue?vue&type=style&index=0&id=938d0ab4&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__